export const NEEDS_ATTENTION_RATE_THRESHOLD = 40;

export const ALL_BUILDINGS_VIEW_KEY = "all_buildings";
export const NEEDS_ATTENTION_VIEW_KEY = "needs_attention";
